var _classCallCheck = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/defineProperty", "react", "deep-object-diff", "../../services/auth", "../../services/context", "../../../../utils/jwt"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/defineProperty"), require("react"), require("deep-object-diff"), require("../../services/auth"), require("../../services/context"), require("../../../../utils/jwt"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.regenerator, a.asyncToGenerator, a.defineProperty, a.react, a.deepObjectDiff, a.auth, a.context, a.jwt), a.index = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e, f, g, h, i) {
  "use strict";

  var j = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.AuthProvider = void 0, b = j(b), c = j(c), d = j(d), e = j(e), h = j(h);
  var k = h.default.Provider;

  var l =
  /*#__PURE__*/
  function (_e$default$Component) {
    _inherits(l, _e$default$Component);

    function l(a) {
      var _this;

      _classCallCheck(this, l);

      var e;
      _this = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, a)), e = _assertThisInitialized(_assertThisInitialized(_this)), (0, d.default)(_assertThisInitialized(_assertThisInitialized(_this)), "authAction",
      /*#__PURE__*/
      function () {
        var a = (0, c.default)(
        /*#__PURE__*/
        b.default.mark(function a(_ref) {
          var c = _ref.login,
              d = _ref.password;
          var f, h, i;
          return b.default.wrap(function (a) {
            for (;;) {
              switch (a.prev = a.next) {
                case 0:
                  return a.next = 2, (0, g.obtainToken)(c, d);

                case 2:
                  if (f = a.sent, !e.isUnmount) {
                    a.next = 5;
                    break;
                  }

                  return a.abrupt("return");

                case 5:
                  h = e.extractTokenData(f), i = h.user, e.setState({
                    authenticated: !0,
                    user: i
                  });

                case 7:
                case "end":
                  return a.stop();
              }
            }
          }, a);
        }));
        return function () {
          return a.apply(this, arguments);
        };
      }()), (0, d.default)(_assertThisInitialized(_assertThisInitialized(_this)), "signupAction",
      /*#__PURE__*/
      function () {
        var a = (0, c.default)(
        /*#__PURE__*/
        b.default.mark(function a(c) {
          return b.default.wrap(function (a) {
            for (;;) {
              switch (a.prev = a.next) {
                case 0:
                  return a.next = 2, (0, g.createToken)(c);

                case 2:
                case "end":
                  return a.stop();
              }
            }
          }, a);
        }));
        return function () {
          return a.apply(this, arguments);
        };
      }()), (0, d.default)(_assertThisInitialized(_assertThisInitialized(_this)), "logoutAction", function () {
        (0, g.clearToken)(), _this.setState({
          authenticated: !1,
          user: null
        });
      });
      var f = (0, g.getToken)();

      if (_this.state = {
        authenticated: !1,
        user: null
      }, !!f) {
        var _a = _this.extractTokenData(f),
            _b = _a.user;

        _this.state = {
          authenticated: !0,
          user: _b
        };
      }

      return _this;
    }

    _createClass(l, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.refreshToken();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.isUnmount = !0;
      } // "Privates"

    }, {
      key: "extractTokenData",
      value: function extractTokenData(a) {
        var b = (0, i.getTokenPayload)(a);
        return b && b.exp && this.delayAutoRefresh(b), b;
      }
    }, {
      key: "delayAutoRefresh",
      value: function delayAutoRefresh(_ref2) {
        var _this2 = this;

        var a = _ref2.exp;
        var b = new Date(1e3 * a),
            c = new Date(Date.now());
        clearTimeout(this.delayTimeout), this.delayTimeout = setTimeout(function () {
          return _this2.refreshToken();
        }, b - c - 60000);
      }
    }, {
      key: "refreshToken",
      value: function refreshToken() {
        var a = this;
        return (0, c.default)(
        /*#__PURE__*/
        b.default.mark(function c() {
          var d, e, h;
          return b.default.wrap(function (b) {
            for (;;) {
              switch (b.prev = b.next) {
                case 0:
                  return b.prev = 0, b.next = 3, (0, g.refreshToken)();

                case 3:
                  if (d = b.sent, !a.isUnmount) {
                    b.next = 6;
                    break;
                  }

                  return b.abrupt("return");

                case 6:
                  e = a.extractTokenData(d), h = e.user, h && a.setState(function (_ref3) {
                    var a = _ref3.user;
                    var b, c;
                    return Object.keys((0, f.diff)(a, h)).length ? Object.keys((0, f.diff)(null === (b = a.modules) || void 0 === b ? void 0 : b.sort(), null === (c = h.modules) || void 0 === c ? void 0 : c.sort())).length ? {
                      authenticated: !0,
                      user: h
                    } : null : null; // Sometimes the api doest not return the same order
                  }), b.next = 15;
                  break;

                case 10:
                  if (b.prev = 10, b.t0 = b["catch"](0), !a.isUnmount) {
                    b.next = 14;
                    break;
                  }

                  return b.abrupt("return");

                case 14:
                  a.setState({
                    authenticated: !1,
                    user: null
                  });

                case 15:
                case "end":
                  return b.stop();
              }
            }
          }, c, null, [[0, 10]]);
        }))();
      }
    }, {
      key: "render",
      value: function render() {
        var a = this.props.children,
            b = this.state,
            c = b.authenticated,
            d = b.user,
            f = this.authAction,
            g = this.logoutAction,
            h = this.signupAction;
        return e.default.createElement(k, {
          value: {
            authenticated: c,
            user: d,
            authAction: f,
            logoutAction: g,
            signupAction: h
          }
        }, a);
      }
    }]);

    return l;
  }(e.default.Component);

  a.AuthProvider = l;
  a.default = l;
});